import React from 'react';

const DeadlineAlertBadge = ({ alert, compact = false }) => {
  if (!alert || alert.level === 'none') {
    return null;
  }

  const getAlertStyle = (level) => {
    switch (level) {
      case 'danger':
        return {
          bg: 'bg-red-100',
          border: 'border-red-400',
          text: 'text-red-700',
          icon: alert.icon || '❌'
        };
      case 'critical':
        return {
          bg: 'bg-orange-100',
          border: 'border-orange-400',
          text: 'text-orange-700',
          icon: alert.icon || '🚨'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-100',
          border: 'border-yellow-400',
          text: 'text-yellow-700',
          icon: alert.icon || '⚠️'
        };
      case 'info':
        return {
          bg: 'bg-blue-100',
          border: 'border-blue-400',
          text: 'text-blue-700',
          icon: alert.icon || '📅'
        };
      default:
        return {
          bg: 'bg-gray-100',
          border: 'border-gray-300',
          text: 'text-gray-700',
          icon: '•'
        };
    }
  };

  const style = getAlertStyle(alert.level);

  if (compact) {
    return (
      <span
        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${style.bg} ${style.text} ${style.border} border`}
        title={alert.message}
      >
        <span className="mr-1">{style.icon}</span>
        {alert.is_overdue ? 'OVERDUE' : alert.message}
      </span>
    );
  }

  return (
    <div
      className={`flex items-start gap-2 p-3 rounded-lg ${style.bg} ${style.border} border`}
    >
      <span className="text-lg">{style.icon}</span>
      <div className="flex-1">
        <div className={`text-sm font-semibold ${style.text}`}>
          {alert.message}
        </div>
        {alert.days_remaining !== null && !alert.is_overdue && (
          <div className={`text-xs ${style.text} mt-1 opacity-80`}>
            {alert.days_remaining} day{alert.days_remaining !== 1 ? 's' : ''} remaining
          </div>
        )}
      </div>
    </div>
  );
};

export default DeadlineAlertBadge;
